import React from 'react'
import ReactGA from 'react-ga'
import { Link } from 'react-router-dom'
import { formatDateUpdated, formatValueDisplay, convertDegreesToIconAngle } from '../../utils/dateAndNumberFormatUtils'

import {
  ModalScreenOverlay,
  MobileStatusContainer,
  SiteStatusPopupHeaderContainer,
  SiteStatusPopupCloseIcon,
  SiteStatusPopupHeaderH1Cell,
  SiteStatusPopupH1,
  SiteStatusPopupHeaderDashboardLinkCell,
  SiteStatusPopupHeaderDashboardLink,
  SiteStatusPopupDateUpdated,
  SiteStatusPopupBodyContainer,
  SiteStatusPopupMetricCell,
  SiteStatusPopupMetricCellInner,
  SiteStatusPopupMetricLabel,
  SiteStatusPopupMetricUnit,
  SiteStatusPopupMetricValue,
  SiteStatusPopupWindContainer,
  SiteStatusPopupWindIcon,
  SiteStatusPopupWindLabel,
  SiteStatusPopupMetricIndicatorBoxRow,
  SiteStatusPopupMetricIndicatorBox,
  SiteStatusPopupAdContainer,
  SiteStatusPopupLink,
  SiteStatusPopupAd,
  SiteStatusPopupAdHeaderSponsoredMsg,
  SiteStatusPopupAdHeadlineTxt,
  SiteStatusPopupAdBodyTxt,
  SiteStatusPopupAdReadMore,
  SiteStatusPopupHeaderHeadingContent
} from './styled-elements'
import { isDataFresh } from "../../utils/mapUtils";

const WindIconAndDirectionLabel  = ({windDirectionValue,windDirectionLabel}) => {
  return <SiteStatusPopupWindContainer>
    <SiteStatusPopupWindIcon angle={convertDegreesToIconAngle(windDirectionValue)}/>
    <SiteStatusPopupWindLabel>
      {windDirectionLabel}
    </SiteStatusPopupWindLabel>
  </SiteStatusPopupWindContainer>
}

const metricToDataViewTypeKeyFallbacks = {
  sigmaw10: ['graph_sigmaw', 'graph_ann_sigma_w'],
  temperature_min_today: ['graph_temperature_min_max_average', 'graph_temperature'],
  temperature_max_today: ['graph_temperature_min_max_average', 'graph_temperature'],
  relative_humidity: ['graph_relative_humidity_delta_t'],
  delta_t: ['graph_relative_humidity_delta_t'],
  wind_speed_2m: ['graph_wind'],
  wind_speed_10m: ['graph_wind'],
  current_day_rainfall: ['graph_rainfall', 'graph_rainfall_totals'],
  previous_day_rainfall: ['graph_rainfall', 'graph_rainfall_totals'],
  rainfall_month: ['graph_rainfall_totals', 'graph_rainfall'],
  rainfall_year: ['graph_rainfall_totals', 'graph_rainfall'],
  evapotranspiration: ['graph_evapotranspiration_total'],
}

export default class SiteStatusPopup extends React.Component {

  constructor(props) {
    super(props)
    this.Overlay = React.createRef()
    this.PopupContainer = React.createRef()
  }

  getBoundingClientRect = () => {
    return this.PopupContainer.current.getBoundingClientRect()
  }

  componentDidUpdate(prevProps) {
  }

  browseToDashBoard(clickItem) {
    const { name, slug, routeToDataViewHandler } = this.props
    ReactGA.event({
      category: 'Site Action',
      action: `View Dashboard from Popup ${clickItem}`,
      label: name,
    })
    routeToDataViewHandler.call(this,slug,'dashboard')
  }

  browseToDataHistory = () => {
    const { name, slug, routeToSiteDataViewsListHandler } = this.props
    ReactGA.event({
      category: 'Site Action',
      action: 'View Site Data Views List from Popup',
      label: name,
    })
    routeToSiteDataViewsListHandler.call(this,slug)
  }

  chartDataViewSlugForMetric = (metricId) => {
    const { siteDataViews } = this.props
    if (!metricId || !siteDataViews || !siteDataViews.length) return null

    const graphDataViews = siteDataViews.filter(({ data_view_type_category, available }) => {
      return (data_view_type_category === 'graph') && (available !== false)
    })

    if (!graphDataViews.length) return null

    const dataViewTypeKeyToSlug = {}
    graphDataViews.forEach(({ data_view_type_key, slug }) => {
      if (!data_view_type_key || !slug) return
      if (!dataViewTypeKeyToSlug[data_view_type_key]) dataViewTypeKeyToSlug[data_view_type_key] = slug
    })

    const metricIdString = String(metricId)
    const dataViewTypeKeys = [
      `graph_${metricIdString}`,
      ...(metricToDataViewTypeKeyFallbacks[metricIdString] || []),
    ]

    const selectedDataViewTypeKey = dataViewTypeKeys.find((dataViewTypeKey) => {
      return !!dataViewTypeKeyToSlug[dataViewTypeKey]
    })

    if (!selectedDataViewTypeKey) return null
    return dataViewTypeKeyToSlug[selectedDataViewTypeKey]
  }

  browseToMetricChart = (clickItem, metricLabel, metricId) => {
    const { name, slug, routeToDataViewHandler } = this.props
    const dataViewSlug = this.chartDataViewSlugForMetric(metricId)

    if (!dataViewSlug) return

    ReactGA.event({
      category: 'Site Action',
      action: `View Chart from Popup ${clickItem}`,
      label: `${name}:${metricLabel}`,
      site: name,
      data_view_name: metricLabel,
    })

    routeToDataViewHandler.call(this,slug,dataViewSlug)
  }

  callCloseActionIfNotMainContainer = (event,closeStatusPopupHandler) => {
    if (event.target === event.currentTarget) closeStatusPopupHandler.call()
  }

  renderBody = (props,state) => {

    const { name, isSignedIn, company, awsType, isMesonet, closeStatusPopupHandler,
      lastUpdated, timezone, siteSummaryDataHash } = props

    const dataIsFresh = isDataFresh(awsType, lastUpdated, 3600000 * 3.5);

    return <ModalScreenOverlay ref={this.Overlay} onClick={e => this.callCloseActionIfNotMainContainer(e,closeStatusPopupHandler)}>
      <MobileStatusContainer ref={this.PopupContainer}>
        <SiteStatusPopupHeaderContainer>
          <SiteStatusPopupCloseIcon
            onClick={closeStatusPopupHandler}
          />
          <SiteStatusPopupHeaderHeadingContent>
            <SiteStatusPopupHeaderH1Cell>
              <SiteStatusPopupH1 onClick={this.browseToDashBoard.bind(this,'Heading')}>
                {name}
              </SiteStatusPopupH1>
            </SiteStatusPopupHeaderH1Cell>
          </SiteStatusPopupHeaderHeadingContent>
          <SiteStatusPopupDateUpdated>
            {formatDateUpdated(lastUpdated,timezone)}
          </SiteStatusPopupDateUpdated>
          {isSignedIn && <SiteStatusPopupHeaderDashboardLinkCell>
            <SiteStatusPopupHeaderDashboardLink onClick={this.browseToDashBoard.bind(this,'Button')}>Dashboard</SiteStatusPopupHeaderDashboardLink>
            <SiteStatusPopupHeaderDashboardLink onClick={this.browseToDataHistory}>Data history</SiteStatusPopupHeaderDashboardLink>
          </SiteStatusPopupHeaderDashboardLinkCell>}
        </SiteStatusPopupHeaderContainer>
        {(1===2) &&
          <SiteStatusPopupAdContainer top>
            <SiteStatusPopupLink href="http://taindata.com" target="_blank">
              <SiteStatusPopupAd top>
                <SiteStatusPopupAdHeaderSponsoredMsg>Sponsored message</SiteStatusPopupAdHeaderSponsoredMsg>
                <SiteStatusPopupAdHeadlineTxt>Soil moisture monitoring, designed for the needs of South Australian growers</SiteStatusPopupAdHeadlineTxt>
                <SiteStatusPopupAdBodyTxt>The TainData Tierra soil moisture data logger has been developed in partnership with leading consultants and growers in South Australia.</SiteStatusPopupAdBodyTxt>
                <SiteStatusPopupAdReadMore>Learn more...</SiteStatusPopupAdReadMore>
              </SiteStatusPopupAd>
            </SiteStatusPopupLink>
          </SiteStatusPopupAdContainer>
        }
        <SiteStatusPopupBodyContainer>
          {siteSummaryDataHash && siteSummaryDataHash.data_array && siteSummaryDataHash.data_array.sort((o) => o.sort_order ).map(({metric_id, label, value, unit, value_str, value_snapshot, wind_direction_value, wind_direction_label, styles, included_in_feature_set, unsupported, hide_in_popup},index) => {
            if ((!isSignedIn) && (value_str==='S')) return undefined
            if (unsupported) return undefined
            if (hide_in_popup) return undefined
            let faded = false
            let showColorBar = true
            const isCalmWind = value_str === 'CALM'
            const displayValue = isCalmWind ? 'Calm' : (value_snapshot ?? value)
            let valueElementStyles = String(displayValue).length > 4 ? { fontSize: "2.4em" } : {};
            const includedInFeatureSet = included_in_feature_set
            const dataViewSlug = this.chartDataViewSlugForMetric(metric_id)
            const chartLinkEnabled = includedInFeatureSet && !!dataViewSlug
            if (isSignedIn && !includedInFeatureSet) {
              faded=true
              showColorBar=false
            }
            return <SiteStatusPopupMetricCell key={index}>
              <SiteStatusPopupMetricCellInner
                faded={faded}
                clickable={chartLinkEnabled}
                onClick={chartLinkEnabled ? this.browseToMetricChart.bind(this,'Tile',label,metric_id) : undefined}
              >
                <SiteStatusPopupMetricLabel>{ label }</SiteStatusPopupMetricLabel>
                <SiteStatusPopupMetricUnit>{ includedInFeatureSet && !isCalmWind && unit }</SiteStatusPopupMetricUnit>
                <SiteStatusPopupMetricValue style={{...valueElementStyles}}>
                  { (includedInFeatureSet && dataIsFresh) ? displayValue :
                    includedInFeatureSet ? "–" : <span style={{ textDecoration: 'underline', cursor: 'pointer' }} onClick={(event) => {
                      event.stopPropagation()
                      props.showUpgradeRequiredModalHandler.call(this)
                    }}>U</span>
                   }
                  { dataIsFresh && !isCalmWind && Number.isInteger(value_snapshot ?? value) && Number.isInteger(wind_direction_value) && <WindIconAndDirectionLabel windDirectionValue={wind_direction_value} windDirectionLabel={wind_direction_label} /> }
                </SiteStatusPopupMetricValue>
                <SiteStatusPopupMetricIndicatorBoxRow>{showColorBar && <SiteStatusPopupMetricIndicatorBox backgroundColor={dataIsFresh ? styles.background_color : "#FFF"}/>}</SiteStatusPopupMetricIndicatorBoxRow>
              </SiteStatusPopupMetricCellInner>
            </SiteStatusPopupMetricCell>
          }).filter((item) => (typeof item!=='undefined'))}
        </SiteStatusPopupBodyContainer>
        {(!isSignedIn) && <div style={{ padding: '0.8em 0.4em', margin: '0.4em' }}>
          <div style={{ fontSize: '1.6em', fontWeight: 700 }}>Log in for more</div>
            <p style={{ fontSize: '1.2em', fontWeight: 500 }}>To view more data from this AWS, <Link to={'/login'}>Log in</Link> or <Link to={'/signup'}>Sign Up</Link>.</p>
          </div>
        }
        {(1===2) &&
        <SiteStatusPopupAdContainer bottom>
          <SiteStatusPopupLink href="http://taindata.com" target="_blank">
            <SiteStatusPopupAd bottom>
              <SiteStatusPopupAdHeaderSponsoredMsg>Sponsored message</SiteStatusPopupAdHeaderSponsoredMsg>
              <SiteStatusPopupAdHeadlineTxt>Soil moisture monitoring, designed for the needs of South Australian growers</SiteStatusPopupAdHeadlineTxt>
              <SiteStatusPopupAdBodyTxt>The TainData Tierra soil moisture data logger has been developed in partnership with leading consultants and growers in South Australia.</SiteStatusPopupAdBodyTxt>
              <SiteStatusPopupAdReadMore>Learn more...</SiteStatusPopupAdReadMore>
            </SiteStatusPopupAd>
          </SiteStatusPopupLink>
          </SiteStatusPopupAdContainer>
        }
      </MobileStatusContainer>
    </ModalScreenOverlay>

  }

  render() {
    return this.renderBody(this.props,this.state)
  }
}
